<template>
    <div>
        <Navbar Title='Typing Speed'/>

        <div class="container">

            <div  class="card">
                
                <div class=" card-content">
                    <h2 style="margin-bottom:2%">Typing Speed</h2>
                    
                    <p>As soon as you start typing the timer🕓 will automatically start counting, and when you have successfully 
                        typed out the given prompt without any typos❗️ your score will be calculated and displayed🧾.</p>
                        <p>Good Luck... 👍</p>
                    <br><br>
                    <div v-if="score" class="center">
                        <p>Your Score</p>
                        <h3 style="margin:0px" class="green-text">{{score}}</h3>
                        <p style="font-size:.75em">words/min</p>
                    </div>
                    
                </div>
                <hr style="margin:0 2%" >
                <p class="center red-text" style="margin-bottom:0px;padding-top:20px">TIME</p>
                <div class="timer mt-3 center red-text">
                    {{ timer }}
                </div>

                <div class=" card-content">

                    <div class="paragraph left" v-for="(char,index) in originalText" :key="index">
                        <pre v-if="typedText[index] && char==typedText[index]" class="green-text">{{char}}</pre>
                        <pre v-else-if="typedText[index] && char!=typedText[index]" class="red-text">{{char}}</pre>
                        <pre v-else>{{char}}</pre>
                    </div>
                    <br>
                    <div class="typer mt-3">
                    <input type="text" class="form-control" placeholder="start typing here" v-model="typedText" @click="startTimer">
                    </div>
                </div>

                <div class="center">
                    <div class="waves-effect waves-light btn" @click.prevent="resetTimer">Restart</div>
                </div>
                
            </div>

            

        </div>


    </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import axios from 'axios';

export default {
    name: 'Typing-speed',
    components: {
        Navbar,
    },
    data(){
        return{
            originalText: null,
            typedText: '',
            score:0,
            typos: 0,
            timer: 0,
            clock:null
        }
    },

    methods:{

        startTimer()
        {
            this.clock = setInterval(() => {
                this.timer++;
            }, 1000);
        },

        resetTimer()
        {
            axios.get('https://api.quotable.io/random').then(el => {
                this.originalText = el.data.content
                console.log(this.originalText)
            });
            this.typedText=''
            clearInterval(this.clock)
            this.timer=0;
        }
    },
    created() {
        axios.get('https://api.quotable.io/random').then(el => {
            this.originalText = el.data.content
        });     
    },

    watch: {
    typedText: function(value) {

        if(value==this.originalText && this.timer>0)
        {
            this.score = Math.trunc((value.length/5)/(this.timer/60));
            event.target.blur();
            this.resetTimer()
        }
    }
  }
    
}
</script>

<style scoped>
.home{
    padding: 15px 10px;
    font-size:250%;
}
.paragraph{
    font-size: 1.em;
}
.paragraph pre{
    margin: 0px;
    font-size: 1.4em;
}
.btn{
    margin: 20px;
}
.timer{
    margin: 20px;
    margin-top: 0px;
    font-size: 1.8em;
}

</style>